module.exports = __webpack_public_path__ + "media/images/linkedIn-icon-1ba02060825624b301e1295489225dab.png";